import React, { useEffect, useState } from "react";
import { Container, Table } from "reactstrap";

export default function MixTable({ jsonData }) {
  const yakuba = jsonData.kushiro_yakuba;
  const microgrid = jsonData.kushiro_microgrid;

  const [rows, setRows] = useState([]);
  const [labelsList, setLabelsList] = useState([]);

  const sumArrays = (arr1, arr2) =>
    arr1?.map((val, idx) => {
      const sum = val + (arr2[idx] || 0);
      return Math.round(sum * 10) / 10;
    });

  const formatToOneDecimal = (num) => {
    if (num === null || num === undefined || num === "") return "-";
    if (Number(num) === 0) return 0;
    return Number(num).toFixed(1);
  };

  const keyHeader = ["項目"];
  const keyAverage = ["気温(℃)"];
  const noDecimal = ["項目", "時間", "日射量(kWh/m²)"];
  const highlightNames = [
    "発電予測量(kWh)役場+MG",
    "需要予測量(kWh)役場+MG",
    "購入予測量(kWh)役場+MG",
  ];
  const mixHeaders = {
    項目: yakuba?.id,
    時間: yakuba?.time,
    "気温(℃)": yakuba?.temperature,
    "日射量(kWh/m²)": yakuba?.radiation,
    "発電予測量(kWh)役場": sumArrays(yakuba?.rooftop_gen, yakuba?.carpot_gen),
    "発電予測量(kWh)MG": microgrid?.generation,
    "発電予測量(kWh)役場+MG": sumArrays(
      sumArrays(yakuba?.rooftop_gen, yakuba?.carpot_gen),
      microgrid?.generation,
    ),
    "需要予測量(kWh)役場": yakuba?.demand,
    "需要予測量(kWh)MG": microgrid?.total_demand,
    "需要予測量(kWh)役場+MG": sumArrays(
      yakuba?.demand,
      microgrid?.total_demand,
    ),
    "購入予測量(kWh)役場": yakuba?.purchase,
    "購入予測量(kWh)MG": microgrid?.purchase,
    "購入予測量(kWh)役場+MG": sumArrays(yakuba?.purchase, microgrid?.purchase),
  };
  const keyTotal = [
    "発電予測量(kWh)役場",
    "発電予測量(kWh)MG",
    "発電予測量(kWh)役場+MG",
    "発電予測量(kWh)",
    "需要予測量(kWh)役場",
    "需要予測量(kWh)MG",
    "需要予測量(kWh)役場+MG",
    "購入予測量(kWh)役場",
    "購入予測量(kWh)MG",
    "購入予測量(kWh)役場+MG",
  ];

  useEffect(() => {
    let maxLength = 0;
    Object.entries(mixHeaders).forEach(([key, value]) => {
      const values = Array.isArray(value) ? value : [value];
      if (values.length > maxLength) {
        maxLength = values.length;
      }
    });
    if (maxLength === 0) maxLength = 48;

    const computedRows = Object.entries(mixHeaders).map(([key, value]) => {
      let values = Array.isArray(value) ? value : [value];

      if (key === "-") {
        values = [];
      }

      if (values.length < maxLength) {
        const padded = new Array(maxLength).fill("");
        for (let i = 0; i < values.length; i++) {
          padded[i] = values[i];
        }
        values = padded;
      }

      let totalOrAverage = "-";
      const numericValues = values.filter((v) => !isNaN(parseFloat(v)));

      if (keyAverage.includes(key) && numericValues.length > 0) {
        totalOrAverage = (
          numericValues.reduce((sum, val) => sum + parseFloat(val), 0) /
          numericValues.length
        ).toFixed(1);
      } else if (keyTotal.includes(key) && numericValues.length > 0) {
        totalOrAverage = numericValues
          .reduce((sum, val) => sum + parseFloat(val), 0)
          .toFixed(1);
      } else if (keyHeader.includes(key)) {
        totalOrAverage = "-";
      }

      return {
        key,
        label: key,
        totalOrAverage,
        values,
      };
    });

    setRows(computedRows);
    setLabelsList(computedRows.map((row) => row.label));
  }, [jsonData]);

  return (
    <Container fluid className="px-5 mt-2">
      <div className="table-layout d-flex">
        <div className="d-flex">
          <div className="table-head ">
            <ul>
              {labelsList.map((label, idx) => (
                <li
                  key={idx}
                  className={` ${
                    label === "購入予測量(kWh)役場+MG" ||
                    label === "需要予測量(kWh)役場+MG" ||
                    label === "発電予測量(kWh)役場+MG"
                      ? "bg2"
                      : ""
                  } `}
                >
                  {label}
                </li>
              ))}
            </ul>
          </div>
          <div className=" table-head table-1">
            <ul>
              {rows.map((row) => {
                const isHighlighted = highlightNames.includes(row.key);

                return (
                  <li key={row.key} className={isHighlighted ? "bg2" : ""}>
                    {row.totalOrAverage}
                  </li>
                );
              })}
            </ul>
          </div>
        </div>

        <Table bordered responsive>
          <tbody>
            {rows.map((row) => (
              <tr key={row.key} className="table-row">
                {row.values.map((val, idx) => (
                  <td
                    className={`table-data ${row.key === "項目" ? "bg" : ""} 
                      ${highlightNames.includes(row.key) ? "table-data1" : ""}`}
                    key={row.key + idx}
                  >
                    {noDecimal.includes(row.key)
                      ? val === null || val === undefined || val === ""
                        ? "-"
                        : val
                      : formatToOneDecimal(val)}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </Table>
      </div>
    </Container>
  );
}
